export default __webpack_public_path__ + "static/media/Thumbnail-2.5ca0b426.svg";